import { reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import api from '@/api/'

function getDepartment(options, project) {
  const platList = []
  const findPlat = (options, project) => {
    if (!Array.isArray(options)) return platList
    options.map(item => {
      if (String(item.parent_id) === String(project)) {
        platList.push(item)
        findPlat(options, item.id)
      }
    })
  }
  findPlat(options, project)
  return platList
}

export default () => {
  const _this = getCurrentInstance()
  const state = reactive({
    project: _this.$route.query.project,
    platformList: [], // 平台列表
  })

  const selfPlatformList = computed(() => {
    if (state.project && state.platformList.length) {
      let childList = []
      const parentPlatformList = state.platformList.filter(item => String(item.id) === String(state.project))
      if (Array.isArray(parentPlatformList) && parentPlatformList.length) {
        childList = getDepartment(state.platformList, parentPlatformList[0].id)
      }
      return [...parentPlatformList, ...childList]
    }
    return []
  })

  onMounted(() => {
    methods.getPlatform()
  })

  const methods = {
    // 获取发布平台列表
    getPlatform: async function () {
      const res = await api.LineListNew()
      state.platformList = res.data
    },
  }

  return {
    selfPlatformList,
    ...toRefs(state),
    ...methods
  }
}
